import React from 'react';
import { useSelector } from 'react-redux';

import { Icon, TooltipWrapper } from '@tcc/crate';
import AveragePlantingPopulationRateRow from './AveragePlantingPopulationRow';
import BagsNeededRow from './BagsNeededRow';
import EstimatedYieldRow from './EstimatedYieldRow';
import SeedCostRow from './SeedCostRow';
import EstimatedGrossRevenueRow from './EstimatedGrossRevenueRow';
import PotentialGainLossRow from './PotentialGainLossRow';

import { getActiveCropNominalWeight } from 'current/currentSelectors';
import { getActiveScenario, getOriginalScenario, getYourPlanScenario } from 'advanced/scenarios/scenarioSelectors';

import { getMessage } from 'util/locale';
import { convertScenarioForLocale } from 'advanced/scenarios/util/convertScenarioForLocale';

const baseString = 'vra-scenarios-table';

const ScenariosTable = () => {
  const cropNominalWeight = useSelector(getActiveCropNominalWeight);
  const originalScenario = useSelector(getOriginalScenario);
  const activeScenario = useSelector(getActiveScenario);
  const yourPlanScenario = useSelector(getYourPlanScenario);
  const convertedOriginalScenario = convertScenarioForLocale({ scenario: originalScenario, cropNominalWeight });
  const convertedActiveScenario = convertScenarioForLocale({ scenario: activeScenario, cropNominalWeight });
  const convertedYourPlanScenario = convertScenarioForLocale({ scenario: yourPlanScenario, cropNominalWeight });
  const orginalProjectedRevenue
    = convertedOriginalScenario.avgEstGrossRevenue.q - convertedOriginalScenario.costSeedPerAcre.q;
  const activeProjectedRevenue
    = convertedActiveScenario.avgEstGrossRevenue.q - convertedActiveScenario.costSeedPerAcre.q;
  const yourPlanProjectedRevenue
    = convertedYourPlanScenario.avgEstGrossRevenue.q - convertedYourPlanScenario.costSeedPerAcre.q;

  return (
    <table className={baseString}>
      <thead>
        <tr>
          <th>{getMessage('details')}</th>
          <th>{getMessage('your-plan')}</th>
          <th>
            {getMessage('text__fieldview-seed-scripts')}
            <TooltipWrapper
              className={`${baseString}__tooltip`}
              content={[getMessage('tooltip-text__scenarios-table')]}
              placement='left'
              testId='review-tooltip'
            >
              <Icon glyph={Icon.set.INFO_CIRCLE} />
            </TooltipWrapper>
          </th>
          <th>{getMessage('new-plan')}</th>
        </tr>
      </thead>
      <tbody>
        <AveragePlantingPopulationRateRow
          originalAvgRate={convertedOriginalScenario.avgRate.q}
          activeAvgRate={convertedActiveScenario.avgRate.q}
          yourPlanAvgRate={convertedYourPlanScenario.avgRate.q}
        />
        <BagsNeededRow
          originalNumSeedBags={convertedOriginalScenario.numSeedBags.q}
          activeNumSeedBags={convertedActiveScenario.numSeedBags.q}
          yourPlanNumSeedBags={convertedYourPlanScenario.numSeedBags.q}
        />
        <EstimatedYieldRow
          originalAvgEstYield={convertedOriginalScenario.avgEstYield.q}
          activeAvgEstYield={convertedActiveScenario.avgEstYield.q}
          yourPlanAvgEstYield={convertedYourPlanScenario.avgEstYield.q}
        />
        <SeedCostRow
          originalCostSeedPerAcre={convertedOriginalScenario.costSeedPerAcre.q}
          activeCostSeedPerAcre={convertedActiveScenario.costSeedPerAcre.q}
          yourPlanCostSeedPerAcre={convertedYourPlanScenario.costSeedPerAcre.q}
        />
        <EstimatedGrossRevenueRow
          orginalProjectedRevenue={orginalProjectedRevenue}
          activeProjectedRevenue={activeProjectedRevenue}
          yourPlanProjectedRevenue={yourPlanProjectedRevenue}
        />
      </tbody>
      <PotentialGainLossRow
        orginalAvgEstGrossRevenue={orginalProjectedRevenue}
        activeAvgEstGrossRevenue={activeProjectedRevenue}
        yourPlanAvgEstGrossRevenue={yourPlanProjectedRevenue}
      />
    </table>
  );
};
export default ScenariosTable;
